import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import VoxelText from '../Text/VoxelText';
import { useMenuContext } from './VoxelMenuLogic';
import VoxelLoadingSpinner from '../Animation/VoxelLoadingSpinner';

export interface VoxelMenuItemProps
  extends Pick<
    ButtonHTMLAttributes<HTMLDivElement>,
    'onClick' | 'onMouseDown' | 'onMouseUp' | 'disabled'
  > {
  icon?: ReactNode;
  submitting?: boolean;
  title: string;
  subtitle?: string;
  disabled?: boolean;
  selected?: boolean;
  error?: boolean;
  active?: boolean;
  keyboardShortcut?: React.ReactNode;
}

export const VoxelMenuItem: React.FC<VoxelMenuItemProps> = ({
  onClick,
  onMouseDown,
  onMouseUp,
  icon,
  submitting,
  title,
  subtitle,
  disabled,
  selected,
  error,
  active,
  keyboardShortcut,
  ...props
}) => {
  const { size } = useMenuContext();
  return (
    <div
      {...props}
      onClick={(e) => {
        if (disabled) return;
        onClick && onClick(e);
      }}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      className={`
        rounded-lg
        ${size === 'md' && 'py-1.5 px-4 gap-4'}
        ${size === 'sm' && 'py-0.5 px-3 gap-4'}
        ${!disabled && ' cursor-pointer  '}
        ${!disabled && ' hover:bg-voxel-gray-100 '}
        flex flex-row items-center justify-start flex-nowrap
        ${selected ? 'bg-voxel-gray-50 ' : ''}
        ${error ? 'bg-error-100/80 hover:bg-error-100 ' : ''}
        ${disabled && 'text-voxel-gray-400'}
      `}
    >
      {(icon || submitting) && (
        <div
          className={`
            grow-0
              ${size === 'sm' && 'w-4'}
              ${size === 'md' && 'w-4'}
            ${disabled ? 'text-voxel-gray-300' : 'text-voxel-gray-450'}
            `}
        >
          {submitting ? <VoxelLoadingSpinner /> : icon}
        </div>
      )}
      <div className="overflow-hidden grow flex-col gap-2">
        <VoxelText
          div
          variant="bread-normal"
          className={`${size === 'sm' ? '!text-[13px]' : '!text-[13px]'}`}
          color="dark"
          userSelectClass="select-none"
          noWrap
          ellipsis
          colorClassName={error ? 'text-error-700' : disabled ? 'text-voxel-gray-400' : undefined}
        >
          {title}
        </VoxelText>
        {!!subtitle?.length && <VoxelText variant="form-caption">{subtitle}</VoxelText>}
      </div>
      <div className={`${selected ? '' : 'hidden'} text-voxel-gray-500 pr-2`}>
        <FontAwesomeIcon icon={faCheck} size={size === 'md' ? 'lg' : 'sm'} />
      </div>
      {keyboardShortcut && (
        <VoxelText variant="form-caption" color="hint">
          {keyboardShortcut}
        </VoxelText>
      )}
    </div>
  );
};

export default VoxelMenuItem;
